<template>
    <CreateModelLayout
        :indexRoute="$route('admin::reminders.index')"
        :storeRoute="$route('admin::reminders.store')"
        :modelNameSingular="__('admin::reminders.reminder')"
        :modelNamePlural="__('admin::reminders.reminders')"
        :form="form"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.frequency')" :error="errors.frequency">
            <Input name="frequency" type="text" :has-error="exists(errors.frequency)" v-model="form.frequency" :required="true" />
            <FrequencyPresets @select="form.frequency = $event" />
        </FormGroup>

    </CreateModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: '',
                    frequency: '@yearly',
                })
            }
        },
    }
</script>
